module.exports = __webpack_public_path__ + "static/media/1569522120161-1569627484.0757e264.jpg";